import { Box, HStack, Text } from '@chakra-ui/react';
import React from 'react';
import moment from 'moment';
import { localise, templateReplace } from '../../../../services/lang/lang';
import date from '../../../../services/ui/date';
import { RenderIf } from '../../RenderIf/RenderIf';
import AiAssistSummary from '../../AiAssistSummary/AiAssistSummary';
import { useTokens } from '../../../../context/TokenProvider';
const RemoteSubmissionPanelHeader = ({ remoteSubmission, hasMultipleContacts, handlePopoverOpened, openedIndex, }) => {
    const tokens = useTokens();
    const isCreatedAtValid = !!remoteSubmission.created_at &&
        moment(remoteSubmission.created_at).isValid();
    const title = hasMultipleContacts
        ? templateReplace(localise('TENANT_REPORT_REFERENCE_AND_CONTACT'), {
            reference: remoteSubmission.reference,
            contact: remoteSubmission.contact.full_name,
        })
        : templateReplace(localise('TENANT_REPORT_REFERENCE'), {
            reference: remoteSubmission.reference,
        });
    return (React.createElement(Box, { "data-testid": "remote_submission_panel_header", display: "flex", justifyContent: "space-between", alignItems: "center" },
        React.createElement(HStack, { alignItems: "center", spacing: tokens.Spacing04 },
            React.createElement(Text, { "data-testid": "remote_submission_panel_header__reference", as: "h3", variant: "dk-800-rg-3" }, title),
            React.createElement(RenderIf, { condition: !!remoteSubmission.ai_assist_summary },
                React.createElement(AiAssistSummary, { handlePopoverOpened: handlePopoverOpened, openedIndex: openedIndex, model: remoteSubmission, title: localise('TENANT_REPORT_SUMMARY'), footer: localise('TENANT_REPORT_SUMMARY_FOOTER'), summary: remoteSubmission.ai_assist_summary }))),
        React.createElement(RenderIf, { condition: isCreatedAtValid },
            React.createElement(Text, { variant: "dk-800-rg-3", "data-testid": "remote_submission_panel_header__date" }, templateReplace(localise('SUBMISSION_DATE'), {
                date: date.standard(remoteSubmission.created_at),
            })))));
};
export default RemoteSubmissionPanelHeader;
